import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { apiEndpoint } from '../../shared/services/api-endpoint';
import { ApiService } from 'src/app/shared/services/api.service'; '../../shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(
    private apiService: ApiService
  ) { }

  sentContactMail(userData: any): Observable<any> {
    return this.apiService.post(`${apiEndpoint.contact_us}`, userData).pipe(
      map(data => {
        return data;
      })
    );
  }

  registerUser(userData: any): Observable<any> {
    return this.apiService.post(`${apiEndpoint.registration}`, userData).pipe(
      map(data => {
        return data;
      })
    );
  }
  getEventList(params: HttpParams): Observable<any> {
    const url = `${apiEndpoint.event}`;
    return this.apiService.get(url, params).pipe(
      map(data => {
        return data;
      })
    );
  }

  getEventDetail(id: any): Observable<any> {
    const url = `${apiEndpoint.event}${id}`;
    return this.apiService.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }


}

